export default (callback, wait = 1000, options = { leading: true, trailing: true }) => {
  let timeoutId = null
  let lastArgs = null
  let lastContext = null
  let lastRunTime = 0

  const throttled = function (...args) {
    const now = Date.now()

    // Disable leading execution by setting lastRunTime to current time
    if (!lastRunTime && options.leading === false) {
      lastRunTime = now
    }

    const remaining = wait - (now - lastRunTime)
    lastArgs = args
    lastContext = this

    if (remaining <= 0 || remaining > wait) {
      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
      }
      lastRunTime = now
      callback.apply(lastContext, lastArgs)

      // Clear variables to prevent memory leaks
      if (!timeoutId) {
        lastContext = lastArgs = null
      }
    } else if (!timeoutId && options.trailing !== false) {
      // Schedule trailing execution
      timeoutId = setTimeout(() => {
        lastRunTime = options.leading === false ? 0 : Date.now()
        timeoutId = null
        callback.apply(lastContext, lastArgs)
        lastContext = lastArgs = null
      }, remaining)
    }
  }

  throttled.cancel = () => {
    clearTimeout(timeoutId)
    timeoutId = null
    lastRunTime = 0
    lastContext = lastArgs = null
  }

  return throttled
}
